import React, {useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faBooks} from '@fortawesome/pro-solid-svg-icons';
import {faHeart} from '@fortawesome/pro-solid-svg-icons';
import {faGlobe} from '@fortawesome/pro-solid-svg-icons';
import {faRobot} from '@fortawesome/pro-solid-svg-icons';
import {faComment} from '@fortawesome/pro-solid-svg-icons';
import {Link} from 'react-router-dom';

const ExploreMenu = ({activeName}) => {

    const colors = {
        'library': 'sandy-brown', 
        'decks': 'burnt-sienna',
        'ai-texts': 'beautiful-blue',
        'feed': 'charcoal'
    };

    const [items, setItems] = useState([
        {'text': "Decks", 'activeName': 'decks', 'icon': faGlobe, 'url': '/decks'},
        {'text': "AI texts", 'activeName': 'ai-texts', 'icon': faRobot, 'url': '/texts'},
        
    ]);
    //{'text': "Forums", 'activeName': 'feed', 'icon': faComment, 'url': '/forums'},
    //{'text': "Favorites", 'activeName': 'favorites', 'icon': faHeart, 'url': '/my-favorites'},
    // 

    return (
        <>
            <div className="flex flex-row overflow-x-auto gap-2 md:gap-8 justify-center">
                {items.map((item, itemIndex)=>(
                    <>
                        <div key={"library_menu_item_"+itemIndex} className="group muted-text whitespace-nowrap text-xs w-26 sm:w-32  lg:text-base lg:w-48">
                            <Link className="no-underline" to={item.url}>
                                {activeName === item.activeName ?
                                    <div className={"font-bold   transition ease-in-out transition-duration-500 cursor-pointer p-2 lg:py-2 lg:px-4 "}>
                                        <div className="flex flex-row place-items-center gap-2 sm:gap-5">
                                            <div className={"font-bold text-base sm:text-lg"}>
                                                <FontAwesomeIcon icon={item.icon} />
                                            </div>
                                            <div className="underline font-bold ">
                                                {item.text}
                                            </div>
                                        </div>
                                    </div>
                                :
                                    <div className={" font-bold transition ease-in-out transition-duration-500 cursor-pointer p-2 lg:py-2 lg:px-4 "}>
                                        <div className="flex flex-row place-items-center gap-2 sm:gap-5">
                                            <div className={" text-base sm:text-lg"}>
                                                <FontAwesomeIcon icon={item.icon} />
                                            </div>
                                            <div className=" text-gray-600 group-hover:font-bold group-hover:underline ">
                                                {item.text}
                                            </div>
                                        </div>
                                    </div>
                                }
                            </Link>
                        </div>
                    </>
                ))}
            </div>
        </>
    )
}

export default ExploreMenu;